export default {
  data() {
    return {
      fieldsData: {
        hint: 'نوع محل ماموریت',
        value: '',
        data: [
          {
            id: 2,
            hint: '',
            value: 'درون شهری',
            data: [
              {
                value: 'محل های ترافیکی',
                id: 3,
                hint: 'نوع محل براساس ترافیک',
                data: [
                  {
                    hint: 'نوع محل براساس معبر',
                    id: 4,
                    value: 'معابر عمومی ترافیکی',
                    data: [
                      { hint: 'نوع معبر', id: 5, value: 'آزادراه', data: [] },
                      { hint: 'نوع معبر', id: 6, value: 'بزرگراه', data: [] },
                      {
                        hint: 'نوع معبر',
                        id: 7,
                        value: 'خیابان اصلی',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 8,
                        value: 'خیابان فرعی',
                        data: [],
                      },
                      { hint: 'نوع معبر', id: 9, value: 'کوچه', data: [] },
                    ],
                  },
                  {
                    hint: 'نوع محل براساس معبر',
                    id: 10,
                    value: 'معابر اختصاصی ترافیکی',
                    data: [
                      {
                        hint: 'نوع معبر',
                        id: 11,
                        value: 'مسکونی (پارکینگ)',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 12,
                        value: 'کارخانه',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 13,
                        value: 'ورزشگاه',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 14,
                        value: 'مراکز آموزشی',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 15,
                        value: 'پادگان ها',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 16,
                        value: 'تفرجگاه',
                        data: [],
                      },
                      { hint: 'نوع معبر', id: 17, value: 'باغ', data: [] },
                      { hint: 'نوع معبر', id: 18, value: 'مزرعه', data: [] },
                      { hint: 'نوع معبر', id: 19, value: 'سایر', data: [] },
                    ],
                  },
                ],
              },
              {
                value: 'محل های غیر ترافیکی',
                id: 20,
                hint: 'نوع محل براساس ترافیک',
                data: [
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 21,
                    value: 'مسکونی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 22,
                    value: 'ورزشی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 23,
                    value: 'مذهبی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 24,
                    value: 'مراکز بهداشتی درمانی',
                    data: [
                      {
                        hint: 'نوع مرکز بهداشتی درمانی',
                        id: 25,
                        value: 'دانشگاهی',
                        data: [
                          {
                            hint: 'نوع مرکز دانشگاهی',
                            id: 26,
                            value: 'درمانی',
                            data: [
                              {
                                hint: 'نوع مرکز دانشگاهی درمانی',
                                id: 27,
                                value: 'بیمارستان',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی درمانی',
                                id: 28,
                                value: 'کلینیک ویژه تخصصی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی درمانی',
                                id: 29,
                                value: 'مراکز درمان بستر',
                                data: [],
                              },
                            ],
                          },
                          {
                            hint: 'نوع مرکز دانشگاهی',
                            id: 30,
                            value: 'بهداشتی',
                            data: [
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 31,
                                value: 'مراکز جامع خدمات سلامت شبانه روزی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 32,
                                value: 'مراکز جامع خدمات سلامت شهری',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 33,
                                value: 'مراکز جامع خدمات سلامت روستایی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 34,
                                value: 'مراکز تسهیلات زایمانی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 35,
                                value: 'مراکز بهداشتی شهری',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 36,
                                value: 'خانه بهداشت',
                                data: [],
                              },
                            ],
                          },
                        ],
                      },
                      {
                        hint: 'نوع مرکز بهداشتی درمانی',
                        id: 37,
                        value: 'غیر دانشگاهی',
                        data: [
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 38,
                            value: 'بیمارستان',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 39,
                            value: 'کلینیک ویژه تخصصی',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 40,
                            value: 'مراکز درمان بستر',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 41,
                            value: 'بیمارستان ها',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 42,
                            value: 'مطب',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 43,
                            value: 'دی کلینیک',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 44,
                            value: 'مراکز شبانه روزی درمانگاه',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 45,
                            value: 'سایر',
                            data: [],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 46,
                    value: 'مراکز آموزشی',
                    data: [
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 47,
                        value: 'مهد کودک',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 48,
                        value: 'مدرسه',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 49,
                        value: 'دانشگاه',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 50,
                        value: 'حوزه علمیه',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 51,
                    value: 'مراکز انتظامی و نظامی',
                    data: [
                      {
                        hint: 'نوع مرکز انتظامی و نظامی',
                        id: 52,
                        value: 'کلانتری',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز انتظامی و نظامی',
                        id: 53,
                        value: 'پادگان',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 54,
                    value: 'زندان',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 55,
                    value: 'صنعتی',
                    data: [
                      {
                        hint: 'نوع مرکز صنعتی',
                        id: 56,
                        value: 'معادن',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز صنعتی',
                        id: 57,
                        value: 'کارخانجات',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز صنعتی',
                        id: 58,
                        value: 'سایر',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 59,
                    value: 'کوهستانی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 60,
                    value: 'تفریحی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 61,
                    value: 'سایر',
                    data: [],
                  },
                ],
              },
            ],
          },
          {
            hint: '',
            value: 'برون شهری',
            data: [
              {
                value: 'محل های ترافیکی',
                id: 63,
                hint: 'نوع محل براساس ترافیک',
                data: [
                  {
                    hint: 'نوع محل براساس معبر',
                    id: 64,
                    value: 'معابر عمومی ترافیکی',
                    data: [
                      {
                        hint: 'نوع معبر',
                        id: 65,
                        value: 'آزادراه',
                        data: [
                          {
                            hint: 'نوع منطقه',
                            id: 66,
                            value: 'منطقه مسکونی',
                            data: [],
                          },
                          {
                            hint: 'نوع منطقه',
                            id: 67,
                            value: 'منطقه غیر مسکونی',
                            data: [],
                          },
                        ],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 68,
                        value: 'بزرگراه',
                        data: [
                          {
                            hint: 'نوع منطقه',
                            id: 69,
                            value: 'منطقه مسکونی',
                            data: [],
                          },
                          {
                            hint: 'نوع منطقه',
                            id: 70,
                            value: 'منطقه غیر مسکونی',
                            data: [],
                          },
                        ],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 71,
                        value: 'جاده اصلی',
                        data: [
                          {
                            hint: 'نوع منطقه',
                            id: 72,
                            value: 'منطقه مسکونی',
                            data: [],
                          },
                          {
                            hint: 'نوع منطقه',
                            id: 73,
                            value: 'منطقه غیر مسکونی',
                            data: [],
                          },
                        ],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 74,
                        value: 'جاده فرعی',
                        data: [
                          {
                            hint: 'نوع منطقه',
                            id: 75,
                            value: 'منطقه مسکونی',
                            data: [],
                          },
                          {
                            hint: 'نوع منطقه',
                            id: 76,
                            value: 'منطقه غیر مسکونی',
                            data: [],
                          },
                        ],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 77,
                        value: 'جاده روستایی',
                        data: [
                          {
                            hint: 'نوع منطقه',
                            id: 78,
                            value: 'منطقه مسکونی',
                            data: [],
                          },
                          {
                            hint: 'نوع منطقه',
                            id: 79,
                            value: 'منطقه غیر مسکونی',
                            data: [],
                          },
                        ],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 80,
                        value: 'جاده شوسه',
                        data: [
                          {
                            hint: 'نوع منطقه',
                            id: 81,
                            value: 'منطقه مسکونی',
                            data: [],
                          },
                          {
                            hint: 'نوع منطقه',
                            id: 82,
                            value: 'منطقه غیر مسکونی',
                            data: [],
                          },
                        ],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 83,
                        value: 'جاده مال رو',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل براساس معبر',
                    id: 84,
                    value: 'معابر اختصاصی ترافیکی',
                    data: [
                      {
                        hint: 'نوع معبر',
                        id: 85,
                        value: 'مسکونی (پارکینگ)',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 86,
                        value: 'کارخانه',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 87,
                        value: 'ورزشگاه',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 88,
                        value: 'مراکز آموزشی',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 89,
                        value: 'پادگان ها',
                        data: [],
                      },
                      {
                        hint: 'نوع معبر',
                        id: 90,
                        value: 'تفرجگاه',
                        data: [],
                      },
                      { hint: 'نوع معبر', id: 91, value: 'باغ', data: [] },
                      { hint: 'نوع معبر', id: 92, value: 'مزرعه', data: [] },
                      { hint: 'نوع معبر', id: 93, value: 'سایر', data: [] },
                    ],
                  },
                ],
              },
              {
                value: 'محل های غیر ترافیکی',
                id: 94,
                hint: 'نوع محل براساس ترافیک',
                data: [
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 95,
                    value: 'مسکونی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 96,
                    value: 'مراکز بهداشتی درمانی',
                    data: [
                      {
                        hint: 'نوع مرکز بهداشتی درمانی',
                        id: 97,
                        value: 'دانشگاهی',
                        data: [
                          {
                            hint: 'نوع مرکز دانشگاهی',
                            id: 98,
                            value: 'درمانی',
                            data: [
                              {
                                hint: 'نوع مرکز دانشگاهی درمانی',
                                id: 99,
                                value: 'بیمارستان',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی درمانی',
                                id: 100,
                                value: 'کلینیک ویژه تخصصی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی درمانی',
                                id: 101,
                                value: 'مراکز درمان بستر',
                                data: [],
                              },
                            ],
                          },
                          {
                            hint: 'نوع مرکز دانشگاهی',
                            id: 102,
                            value: 'بهداشتی',
                            data: [
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 103,
                                value: 'مراکز جامع خدمات سلامت شبانه روزی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 104,
                                value: 'مراکز جامع خدمات سلامت شهری',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 105,
                                value: 'مراکز جامع خدمات سلامت روستایی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 106,
                                value: 'مراکز تسهیلات زایمانی',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 107,
                                value: 'مراکز بهداشتی شهری',
                                data: [],
                              },
                              {
                                hint: 'نوع مرکز دانشگاهی بهداشتی',
                                id: 108,
                                value: 'خانه بهداشت',
                                data: [],
                              },
                            ],
                          },
                        ],
                      },
                      {
                        hint: 'نوع مرکز بهداشتی درمانی',
                        id: 109,
                        value: 'غیر دانشگاهی',
                        data: [
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 110,
                            value: 'بیمارستان',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 111,
                            value: 'کلینیک ویژه تخصصی',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 112,
                            value: 'مراکز درمان بستر',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 113,
                            value: 'بیمارستان ها',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 114,
                            value: 'مطب',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 115,
                            value: 'دی کلینیک',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 116,
                            value: 'مراکز شبانه روزی درمانگاه',
                            data: [],
                          },
                          {
                            hint: 'نوع مرکز غیر دانشگاهی',
                            id: 117,
                            value: 'سایر',
                            data: [],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 118,
                    value: 'مراکز آموزشی',
                    data: [
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 119,
                        value: 'مهد کودک',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 120,
                        value: 'مدرسه',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 121,
                        value: 'دانشگاه',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز آموزشی',
                        id: 122,
                        value: 'حوزه علمیه',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 123,
                    value: 'مراکز انتظامی و نظامی',
                    data: [
                      {
                        hint: 'نوع مرکز انتظامی و نظامی',
                        id: 124,
                        value: 'کلانتری',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز انتظامی و نظامی',
                        id: 125,
                        value: 'پادگان',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 126,
                    value: 'زندان',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 127,
                    value: 'صنعتی',
                    data: [
                      {
                        hint: 'نوع مرکز صنعتی',
                        id: 128,
                        value: 'معادن',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز صنعتی',
                        id: 129,
                        value: 'کارخانجات',
                        data: [],
                      },
                      {
                        hint: 'نوع مرکز صنعتی',
                        id: 130,
                        value: 'سایر',
                        data: [],
                      },
                    ],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 131,
                    value: 'کوهستانی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 132,
                    value: 'تفریحی',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 133,
                    value: 'جاده',
                    data: [],
                  },
                  {
                    hint: 'نوع محل ماموریت غیر ترافیکی',
                    id: 134,
                    value: 'روستا',
                    data: [],
                  },
                ],
              },
            ],
            id: 62,
          },
        ],
        id: 1,
      },
    };
  },
};
